exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h4 span[data-v-74e3a402]{padding-top:1.2rem}.gl-transactions-row[data-v-74e3a402]{display:grid;grid-gap:10px;grid-template-columns:1fr 2fr .5fr .5fr;font-size:.8rem;border-bottom:1px solid #e8e8e8}.gl-transactions-row div[data-v-74e3a402]{padding:.5rem}.gl-transactions-row[data-v-74e3a402]:nth-child(odd){background:#fafafa}.gl-transactions-row .full-col[data-v-74e3a402]{grid-column:span 4;padding-top:-1rem}.vue-monthly-picker .input[data-v-74e3a402]{max-width:100px!important;margin-right:0;margin-left:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-74e3a402","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/accounting/general-ledger/accounts/AccountDetails.vue
// module id = N8dj
// module chunks = 0 1